<script>
    import { afterUpdate } from "svelte";
    import { fade } from "svelte/transition";

    import { sections } from "../stores";
    import { newRow } from "../constants";
    import Column from "./Column.svelte";

    export let sectionIndex;
    export let rowIndex;

    let showAddRowMenu = false;
    let showRowSizeMenu = false;

    let row = $sections[sectionIndex].rows[rowIndex];

    function addRow() {
        $sections[sectionIndex].rows = [
            ...$sections[sectionIndex].rows,
            newRow,
        ];
    }
    afterUpdate(() => {
        console.log("after row update: ", $sections);
        row = $sections[sectionIndex].rows[rowIndex];
    });
</script>

<div class="row df-row">
    <!-- {#if showRowSizeMenu}
                Row Size stuff
            {:else}
                <div class="df-row-size-btn shadow-sm" on:click={() => showRowSizeMenu = true}>+</div>
            {/if} -->

    {#if row.cols}
        {#each row.cols as col, colIndex}
            <Column {col} {sectionIndex} {rowIndex} {colIndex} />
        {/each}
    {/if}
    <div
        class="df-addcontent-line"
        style="transition: all 200ms ease-in-out;"
        on:click={addRow}
    >
        <span class="df-plusbutton">+</span>
    </div>
</div>

<style>
    .df-plusbutton {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background: #242424;
        color: #ffffff;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 5px;
        justify-self: center;
        margin: 0 auto;
        z-index: 999;
        margin-top: -8px;
    }
    .df-addcontent-line {
        border-radius: 2px;
        cursor: pointer;
        visibility: hidden;
        height: 4px;
        background: #ffffff;
        position: absolute;
        bottom: 0px;
        left: 0px;
        width: 100%;
    }
    .df-row {
        padding: 20px;
        position: relative;
    }
    .df-row:hover .df-add-content-btn .df-row-size-btn {
        visibility: visible;
    }
    .df-row:hover .df-addcontent-line {
        visibility: visible;
        background-color: #242424;
    }

    .df-add-content-btn {
        visibility: hidden;
        animation: visibility 400;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #e8e8e8;
        border-radius: 20px;
        color: #242424;
        width: 50px;
        text-align: center;
        cursor: pointer;
        height: 25px;
        margin: 0 auto;
        margin-bottom: -35px;
        z-index: 90;
    }
    .df-row-size-btn {
        /* visibility: hidden; */
        position: absolute;
        animation: visibility 400;
        align-items: center;
        justify-content: center;
        background: #e8e8e8;
        border-radius: 7px;
        color: #242424;
        width: 200px;
        text-align: center;
        cursor: pointer;
        height: 25px;
        margin: 0 auto;
        margin-top: -35px;
        z-index: 99;
    }
</style>
